import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PatientModel, SkillAreaModel } from '../../../core/api/models';
import { SupervisorApiService } from '../../../core/api/services';
import { SupervisorHelperService } from '../../supervisor.helper.service';
import { AlertService } from '../../../shared/services/alert.service';
import { Utils } from '../../../core/utils';

@Component({
  selector: 'app-add-skill-area',
  templateUrl: './add-skill-area.component.html',
  styleUrl: './add-skill-area.component.css',
  standalone: false,
})
export class AddSkillAreaComponent {
  skillAreaToEdit: SkillAreaModel | null = null;

  @Input() selectedPatient: PatientModel | null = null;
  @Output() close = new EventEmitter<boolean>();

  loading: boolean = false;

  titleName: string = 'Add Skill Area';
  actionName: string = 'Add';

  skillAreaId: number | null = null;
  enteredName = '';

  constructor(
    private supervisorApiService: SupervisorApiService,
    private supervisorHelperService: SupervisorHelperService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    // EDIT LOGIC
    if (this.supervisorHelperService.skillAreaToEdit() != null) {
      this.titleName = 'Edit Skill Area';
      this.actionName = 'Save';
      this.skillAreaToEdit = this.supervisorHelperService.skillAreaToEdit();
      this.skillAreaId = this.skillAreaToEdit?.ID ?? null;
      this.enteredName = this.skillAreaToEdit?.SkillAreaName ?? '';
    }
  }

  onCancel() {
    this.close.emit(false);
  }

  onSubmit() {
    this.loading = true;
    this.supervisorApiService
      .SaveSkillArea({
        body: {
          ID: this.skillAreaId,
          SkillAreaName: this.enteredName,
          PatientID: this.selectedPatient?.ID,
        },
      })
      .subscribe(
        (skillArea) => {
          console.log(skillArea);
          this.loading = false;
          this.alertService.success('Skill Area saved successfully');
          this.close.emit(true);
        },
        (error) => {
          console.error(error);
          this.alertService.error(
            Utils.getErrorMessageFromErrorResponse(error)
          );
          this.loading = false;
          this.close.emit(false);
        }
      );
  }
}
